"use strict";
/*!
 * Copyright (C) 2019, NewFoundry, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;
exports.Rule = void 0;

var lodash_1 = __importDefault(require("lodash"));

var uuid_1 = require("uuid");

var Terms_1 = require("./Terms/");

var Token_1 = require("./Token");

var Tokenizer_1 = require("./Tokenizer");

var Buffer = function () {
  function Buffer(start) {
    if (start === void 0) {
      start = 0;
    }

    this.index = 0;
    this.tokens = [];
    this.index = start;
  }

  Buffer.prototype.contains = function (token) {
    if (!(token instanceof Token_1.Token)) {
      return false;
    }

    return this.tokens.some(function (t) {
      return t instanceof Token_1.Token && t.id === token.id;
    });
  };

  Buffer.prototype.concat = function (tokens) {
    this.tokens = this.tokens.concat(tokens);
    this.index += tokens.length;
  };

  Buffer.prototype.finish = function () {
    return this.tokens;
  };

  Buffer.prototype.length = function () {
    return this.tokens.length;
  };

  Buffer.prototype.pop = function () {
    this.tokens.pop();
    this.index -= 1;
  };

  Buffer.prototype.push = function (token) {
    this.tokens.push(token);
    this.index += 1;
  };

  return Buffer;
}();

var Rule = function () {
  function Rule(rule) {
    this.id = uuid_1.v4();
    this.tokens = Tokenizer_1.Tokenizer.run(rule);
    this.orig = rule;
  }

  Rule.prototype.getCondition = function () {
    var thenToken = lodash_1["default"].find(this.tokens, function (t) {
      return t.token === Terms_1.Then.token;
    });
    return lodash_1["default"].cloneDeep(this.tokens.slice(1, thenToken.index));
  };

  Rule.getClauseAt = function (relativeIndex, tokens) {
    var buffer = new Buffer(relativeIndex);

    while (buffer.index < tokens.length) {
      var conjunction = tokens[buffer.index];

      if (!(conjunction instanceof Token_1.Token) || !lodash_1["default"].includes([Terms_1.And.token, Terms_1.Or.token], conjunction.token)) {
        return buffer.tokens;
      }

      var before = [tokens[buffer.index - 1]];

      if (before[0] instanceof Token_1.Token && before[0].Falsy) {
        before = [tokens[buffer.index - 2], tokens[buffer.index - 1]];
      }

      before = before.filter(function (b) {
        return !buffer.contains(b);
      });
      var after = tokens[buffer.index + 1];

      if (Terms_1.Falsy.is(after) || lodash_1["default"].isUndefined(after)) {
        after = [tokens[buffer.index + 1], tokens[buffer.index + 2]];
      }

      buffer.concat(lodash_1["default"].flatten([before, conjunction, after]));
      buffer.index -= before.length;

      if (before instanceof Token_1.Token && lodash_1["default"].includes([Terms_1.GroupOpen.token, Terms_1.GroupClose.token], before.token)) {}

      if (after instanceof Token_1.Token && lodash_1["default"].includes([Terms_1.GroupOpen.token, Terms_1.GroupClose.token], after.token)) {
        var group = Rule.getGroupAt(buffer.index - 1, tokens);
        buffer.concat(group);
        buffer.push(tokens[buffer.index]);
      }
    }

    return buffer.finish();
  };

  Rule.prototype.getGroups = function () {
    var _this = this;

    var groups = [];
    var opens = this.tokens.filter(function (t) {
      return t.token === Terms_1.GroupOpen.token;
    });
    opens.forEach(function (open) {
      var group = Rule.getGroupAt(open.index, _this.tokens);
      groups.push(group);
    });
    return groups;
  };

  Rule.getGroupAt = function (relativeIndex, tokens) {
    var buffer = [];
    var groupLevel = 1;
    var group = tokens.slice(relativeIndex + 1);
    group.forEach(function (t) {
      if (groupLevel === 0) {
        return;
      }

      if (t instanceof Token_1.Token) {
        switch (t.token) {
          case Terms_1.GroupClose.token:
            groupLevel--;

            if (groupLevel === 0) {
              return;
            }

            break;

          case Terms_1.GroupOpen.token:
            groupLevel++;
            break;
        }
      }

      buffer.push(t);
    });
    return buffer;
  };

  Rule.getGroupAtEnd = function (relativeIndex, tokens) {
    var buffer = [];
    var groupLevel = 1;
    var group = tokens.slice(0, relativeIndex);
    group.reverse().forEach(function (t) {
      if (groupLevel === 0) {
        return;
      }

      if (t instanceof Token_1.Token) {
        switch (t.token) {
          case Terms_1.GroupOpen.token:
            groupLevel--;

            if (groupLevel === 0) {
              return;
            }

            break;

          case Terms_1.GroupClose.token:
            groupLevel++;
            break;
        }
      }

      buffer.push(t);
    });
    return buffer.reverse();
  };

  Rule.prototype.getResult = function () {
    var thenToken = lodash_1["default"].find(this.tokens, function (t) {
      return t.token === Terms_1.Then.token;
    });
    return lodash_1["default"].cloneDeep(this.tokens.slice(thenToken.index + 1));
  };

  return Rule;
}();

exports.Rule = Rule;